<div class="report-designer-host"
     [class.widget-header-mode]="rdStorage.appWidgetHeaderMode$ | async"
     [class.widget-edit-mode]="!(rdStorage.appWidgetHeaderMode$ | async) && (rdStorage.appEditMode$ | async)">
  <div class="toolbar">
    <report-designer-toolbar [main]="this"></report-designer-toolbar>
  </div>
  <div id="reportDesignerModule">
    <div class="areaModuleContainerInner">
      <div id="report-designer-sidebar" class="reportDesignerSidebar" [style.width.px]="paneWidths.get('#report-designer-sidebar')" *ngIf="showSidebar">
        <report-designer-widget-list [main]="this"></report-designer-widget-list>
      </div>
      <div id="report-designer-document" [class]="documentClassesHtml$ | async">
        <report-designer-document [main]="this"></report-designer-document>
      </div>
      <div id="report-designer-infobar" class="reportDesignerInfobar" [style.width.px]="(infoBarVisibility ? paneWidths.get('#report-designer-infobar'):0)" [hidden]="!infoBarVisibility">
        <report-designer-infobar [main]="this"></report-designer-infobar>
      </div>
    </div>
  </div>
</div>


<app-confirm-dialog></app-confirm-dialog>
<save-template-dialog></save-template-dialog>
<print-dialog></print-dialog>
<load-template-dialog></load-template-dialog>
<delete-template-dialog></delete-template-dialog>
